export default {
  "luckWheelDailyStatisticsReport.title": "Luck Wheel Daily Statistics Report",
  "luckWheelDailyStatisticsReport.column.no": "#NO",
  "luckWheelDailyStatisticsReport.column.userNo": "UserNo",
  "luckWheelDailyStatisticsReport.column.email": "Email",
  "luckWheelDailyStatisticsReport.column.name": "Name",
  "luckWheelDailyStatisticsReport.column.inviterUserno": "Inviter UserNo",
  "luckWheelDailyStatisticsReport.column.inviterEmail": "Inviter Email",
  "luckWheelDailyStatisticsReport.column.inviterName": "Inviter Name",
  "luckWheelDailyStatisticsReport.column.channel": "Channel",
  "luckWheelDailyStatisticsReport.column.referral": "Referral",
  "luckWheelDailyStatisticsReport.column.vipLevel": "Vip Level",
  "luckWheelDailyStatisticsReport.column.lastLoginIp": "Last Login IP",
  "luckWheelDailyStatisticsReport.column.bonusAmount": "Bonus Amount",
  "luckWheelDailyStatisticsReport.column.todayReceiveNum": "Today Receive Num",
  "luckWheelDailyStatisticsReport.column.yesterdayReceiveNum": "Yesterday Receive Num",
  "luckWheelDailyStatisticsReport.column.totalReceiveNum": "Total Receive Num",
  "luckWheelDailyStatisticsReport.column.lastReceiveTime": "Last Receive Time",
  "luckWheelDailyStatisticsReport.search.createTime": "Create Time",
  "luckWheelDailyStatisticsReport.search.userNo": "UserNo",
  "luckWheelDailyStatisticsReport.search.email": "Email",
  "luckWheelDailyStatisticsReport.search.inviterUserno": "Inviter UserNo",
  "luckWheelDailyStatisticsReport.search.inviterEmail": "Inviter Email",
  "luckWheelDailyStatisticsReport.search.inviterFirstName": "Inviter First Name",
  "luckWheelDailyStatisticsReport.search.inviterLastName": "Inviter Last Name",
  "luckWheelDailyStatisticsReport.search.vipLevel": "Vip Level",
  "luckWheelDailyStatisticsReport.tooltip.copy.userNo": "Copy UserNo: {text}",
  "luckWheelDailyStatisticsReport.copy.success": "Copied to clipboard",
  "luckWheelDailyStatisticsReport.search": "Search",
};